module.exports = __webpack_public_path__ + "img/ideal.1136b27.svg";